module.exports = __webpack_public_path__ + "img/lock.3aea9aa5.svg";